import { gql } from "graphql-request";

import { client } from "@krea/customer-features/graphql";
import { LOAN_APPLICATION_EXTENDED_FRAGMENT } from "@krea/customer-features/graphql/loan-application/loan-application-extended.fragment";
import { ILoanApplicationExtended } from "@krea/customer-features/types/loanApplication";

const LOAN_APPLICATION_GET_QUERY = gql`
  query GetLoanApplication($loanApplicationId: int!) {
    loanApplication(loanApplicationId: $loanApplicationId) {
      ...LoanApplicationExtendedFragment
    }
  }
  ${LOAN_APPLICATION_EXTENDED_FRAGMENT}
`;

export interface ILoanApplicationGetQueryData {
  loanApplication: ILoanApplicationExtended;
}

// eslint-disable-next-line @typescript-eslint/consistent-type-definitions
export type ILoanApplicationGetQueryVariables = {
  loanApplicationId: string;
};

export const loanApplicationGetQuery = async (
  variables: ILoanApplicationGetQueryVariables,
) => {
  return await client.request<
    ILoanApplicationGetQueryData,
    ILoanApplicationGetQueryVariables
  >({
    document: LOAN_APPLICATION_GET_QUERY,
    variables,
  });
};
